export default __webpack_public_path__ + "static/media/trace.a8dea350.svg";